import React from 'react';
import withIcon from '../utilities/withIcon';

const IconInbox = () => {
  return (
    <g>
      <path d="M12.074 1a.75.75 0 0 1 .614.32l.054.09 3.177 6.25c.035.084.06.173.072.266l.009.141v4.883a2.05 2.05 0 0 1-1.897 2.044L13.95 15H2.05a2.05 2.05 0 0 1-2.044-1.897L0 12.95v-4.9c0-.198.055-.383.15-.541l2.805-6.073a.75.75 0 0 1 .572-.428L3.636 1h8.438zM1.5 8.5v4.45c0 .273.2.5.46.543l.09.007h11.9c.273 0 .5-.2.543-.46l.007-.09V8.516l-3.045-.005a4.004 4.004 0 0 1-3.287 2.467l-.212.017L7.75 11a4.002 4.002 0 0 1-3.549-2.152l-.091-.187-.068-.158L1.5 8.5zm10.113-6.001H4.115L2.036 7.001l2.553.003a.75.75 0 0 1 .698.478l.03.099a2.501 2.501 0 0 0 4.864.005.75.75 0 0 1 .628-.568l.103-.007 2.996.004-2.295-4.516z" />
    </g>
  );
};

export default withIcon(IconInbox);
